/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Use_Local_Storage_HelpInputs */



/**
* | output |
* | --- |
* | "Use local storage when saving project files" |
*
* @param {Options_General_Use_Local_Storage_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_use_local_storage_help = /** @type {((inputs?: Options_General_Use_Local_Storage_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Use_Local_Storage_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le stockage local lors de l'enregistrement des fichiers de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie den lokalen Speicher zum Speichern von Projektdateien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizzare l'archiviazione locale quando si salvano i file di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте локальное хранилище при сохранении файлов проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice el almacenamiento local al guardar archivos de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存项目文件时使用本地存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイルを保存するときにローカルストレージを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइलों को सहेजते समय स्थानीय संग्रहण का उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Utilize o armazenamento local ao salvar arquivos de projeto.")
	return /** @type {LocalizedString} */ ("Use local storage when saving project files")
});